const certificatesDataItems=[
{certificateUrl:'https://drive.google.com/file/d/1I7G7wWV3P9GDhobf5c3MV8gbNu_anqW0/view?usp=sharing',certificateBackground:'/assets/images/aws.jpg'},
{certificateUrl:'https://graduation.udacity.com/confirm/GHSZ4CPV',certificateBackground:'/assets/images/udacity.png'},
{certificateUrl:'https://www.credly.com/badges/b40a1452-aef4-4fc8-9cde-ef2560755918?source=linked_in_profile',certificateBackground:'/assets/images/aws.jpg'},
{certificateUrl:'https://www.coursera.org/account/accomplishments/certificate/6DM2FSXFQUD3',certificateBackground:'/assets/images/coursera-logo-full-rgb.png'},
{certificateUrl:'https://www.hackerrank.com/certificates/5045ace0fb7f',certificateBackground:'/assets/images/HackerRank.png'},
{certificateUrl:"https://www.coursera.org/account/accomplishments/certificate/RG89TQ452RRJ",certificateBackground:'/assets/images/coursera-logo-full-rgb.png'}
]


export default certificatesDataItems